// import { ILangs } from '../../types/configuration';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { IEzugiDTO, IEzugiGetToken } from '../../types/interfaces/LiveCasino/EzugiDTO';
import { getCategories } from '../../utils/liveCasinoSort';
import { hideGames } from './utils';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IEzugiDTO[]>): ISlotViewItem[] =>
    data
      .filter(t => !hideGames.includes(t.TableId))
      .map((item: IEzugiDTO) => ({
        id: item.TableId.toString(),
        gameId: item.TableId.toString(),
        gameName: item.TableName,
        type: CasinoType.liveCasino,
        description: item.TableName,
        provider: 'ezugi',
        imageUrl: `/images/ezugi/${item.TableName.toLowerCase().split(' ').join('_')}.png`,
        routeProvider: 'ezugi',
        tab: getCategories(item.TableName, item.TableId.toString(), 'ezugi'),
      }));

  convertGameUrl = ({ data }: IGetGameUrl<IEzugiGetToken, unknown>) => data.frame_url;
}
export default Converter;
